"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleHubService = void 0;

var inversify_1 = require("inversify");

var http_1 = require("@xbox/http");

var typings_1 = require("../../typings");

var utils_1 = require("../../utils");

var TitleQueries_1 = require("../../queries/TitleQueries");

var TitleHubService =
/** @class */
function () {
  function TitleHubService(xblService, xblGraphQlService) {
    this.xblService = xblService;
    this.xblGraphQlService = xblGraphQlService;
  }

  TitleHubService.prototype.getAllTitles = function () {
    var headers = utils_1.GetGenericHeaders(2);
    return this.xblService.sendRequest({
      url: "https://titlehub.xboxlive.com/titles/win32/decoration/min,scid",
      method: http_1.Http.HttpRequestMethod.Get,
      headers: headers
    });
  };

  TitleHubService.prototype.hydrateTitles = function (gameTitleIds, decoration) {
    if (decoration === void 0) {
      decoration = "min,scid";
    }

    var headers = utils_1.GetGenericHeaders(2);
    var requestData = {
      pfns: null,
      titleIds: gameTitleIds
    };
    return this.xblService.sendRequest({
      url: "https://titlehub.xboxlive.com/titles/batch/decoration/" + decoration,
      method: http_1.Http.HttpRequestMethod.Post,
      data: JSON.stringify(requestData),
      headers: headers
    });
  };

  TitleHubService.prototype.getTitlesForXuid = function (xuid, maxItems) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.xblGraphQlService.query({
              query: TitleQueries_1.TitlesForXuid,
              variables: {
                xuid: xuid,
                first: maxItems ? maxItems : 100
              }
            })];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  TitleHubService.prototype.getTitlesForPfn = function (pfn, maxItems) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.xblGraphQlService.query({
              query: TitleQueries_1.TitlesForPfn,
              variables: {
                pfn: pfn,
                first: maxItems ? maxItems : 100
              }
            })];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  TitleHubService.prototype.getTitlesForTitleIds = function (titleIds) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.xblGraphQlService.query({
              query: TitleQueries_1.TitlesForTitleIds,
              variables: {
                titleIds: titleIds
              }
            })];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  TitleHubService.prototype.searchGameInMsCatalog = function (data, platform) {
    var headers = utils_1.GetGenericHeaders(8);
    var query = "query=" + data.searchStr + "&%24top=" + data.pageSize + "&market=US&languages=en-US&%24skip=" + data.skip + "&fieldsTemplate=details";
    var specifics = "platformdependencyname=" + platform + "&isAddon=" + data.isAddon + "&isDemo=" + data.isDemo + "&actionFilter=Browse";
    return this.xblService.sendRequest({
      url: "https://displaycatalog.mp.microsoft.com/v7.0/productFamilies/Games/products?" + query + "&" + specifics,
      method: http_1.Http.HttpRequestMethod.Get,
      headers: headers
    });
  };

  TitleHubService = __decorate([inversify_1.injectable(), __param(0, inversify_1.inject(typings_1.XSocialSymbols.IXboxLiveRequestService)), __param(1, inversify_1.inject(typings_1.XSocialSymbols.IGraphQLClient)), __metadata("design:paramtypes", [Object, Object])], TitleHubService);
  return TitleHubService;
}();

exports.TitleHubService = TitleHubService;